// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"Previews_modalBody__3duUM","pre_box":"Previews_pre_box__2Cft4"};